import React from "react";
import { apercuNavigateur } from "../lib/emailjs-loader";
import { baseVisee } from "../lib/base-visee";

// BANDEAU D'APERÇU (décision Dimitri 29/09). Un aperçu Vercel lit et écrit
// la VRAIE base (pas de base séparée : décision de ne pas payer un second
// projet). Le point 16a l'empêche d'envoyer quoi que ce soit (Beds24 —
// lecture comprise depuis le 01/10 —, e-mails, SMS, Stripe, Telegram,
// WhatsApp, boîte mail IMAP) — mais pas d'enregistrer en base. Ce
// bandeau le dit, en haut de chaque page, sans jamais s'afficher en
// production (même règle que apercuNavigateur : « production » et « local »
// → rien).
// P-2.57 (30/10) : le bandeau dit la base que le bundle vise VRAIMENT (adresse
// Supabase du navigateur), et non plus « DONNÉES RÉELLES » sur tout aperçu.
// Base inconnue = rouge, comme la réelle : on ne présume jamais l'essai.
export function texteBandeau(visee) {
  if (visee.base === "essai")
    return `APERÇU — BASE D'ESSAI (${visee.ref}) : aucune donnée réelle`;
  if (visee.base === "reelle")
    return `APERÇU — DONNÉES RÉELLES (base ${visee.ref}) : ne rien enregistrer`;
  return `APERÇU — BASE INCONNUE (${visee.ref || "adresse illisible"}) : ne rien enregistrer`;
}

export default function ApercuBandeau({ env } = {}) {
  const e = env || process.env;
  if (!apercuNavigateur(e)) return null;
  const visee = baseVisee(e);
  return (
    <div
      role="alert"
      data-testid="apercu-bandeau"
      data-base={visee.base}
      style={{
        position: "sticky",
        top: 0,
        zIndex: 2147483000,
        background: visee.base === "essai" ? "#3d4a45" : "#b3261e",
        color: "#ffffff",
        fontWeight: 700,
        fontSize: 15,
        letterSpacing: 0.3,
        textAlign: "center",
        padding: "10px 16px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
      }}
    >
      {texteBandeau(visee)}
    </div>
  );
}
